import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';
import { isMobile } from 'react-device-detect';

export const Container = styled(Box)({
  position: 'absolute',
  top: isMobile ? '' : '50%',
  bottom: isMobile ? '216px' : '',
  left: '50%',
  transform: isMobile ? 'translate(-50%, 0%)' : 'translate(-50%, -50%)',
  width: 327,
  borderRadius: '16px',
  paddingBottom: '3px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const Title = styled(Typography)({
  fontWeight: 600,
  fontSize: 20,
  textAlign: 'center',
  lineHeight: 'normal',
  marginTop: 16,
});

export const Subtitle = styled(Typography)({
  fontWeight: 400,
  fontSize: 12,
  textAlign: 'center',
  lineHeight: '18px',
  width: 'fit-content',
  alignSelf: 'center',
});

export const Btn = styled(Button)(({ theme }) => ({
  wordBreak: 'break-word',
  fontWeight: 600,
  fontSize: 14,
  width: 295,
  height: 48,
  borderRadius: 8,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  cursor: 'pointer',
  textTransform: 'none',
  margin: '8px auto 16px',
  padding: 0,
  '&:active': {
    transition: '0.3s',
    transform: 'scale(0.98)',
  },
}));
